<template>
  <div class="main main--customers">
    <div class="main__title main__title--3row">
      <div></div>
      <h2>線上課程</h2>
      <div class="icon">
      </div>
    </div>
    <div class="main__list main__list--courses">
      <div
        v-for="(course, index) in onlineCourse"
        :key="index"
      >
        <router-link exact v-on:click.native="changeNav(0)" :to="'/dashboard/online-course/' + course.courseId">
          <div class="course-box">
            <div class="course-box__image">
              <img :src="course.courseProfileUrl" alt="Smiley face" width="100%">
            </div>
            <div class="course-box__info">
              <h3>{{ course.courseName }}</h3>
              <div>{{ course.courseInfo.substring(0,120) }}⋯⋯</div>
            </div>
          </div>
        </router-link>`
      </div>`
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['onlineCourse'])
  },
  data () {
    return {
      reviewCourses: [
        {}, {}
      ]
    }
  },
  methods: {
    push () {
      this.$router.push({ path: 'fdjfjk' })
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 680px) {
  .main__list {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}
@media (min-width: 980px) {
  .main__list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (min-width: 1280px) {
  .main__list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}
.course-box {
  margin: 2rem;
  box-shadow: 0 0 10px #d9d9d9;
  border-radius: 1rem;
  overflow: hidden;
  .course-box__image {
    height: 180px;
    background: pink;
    overflow: hidden;
  }
  .course-box__info {
    padding: 1.5rem;
    h3 {
      font-size: 1.5rem;
      margin-bottom: 6px;
    }
  }
}
</style>
